import { Route, useParams } from 'react-router-dom';
import Stylingsview from '../Components/Lib/Designer/Views/Stylingsview';
import { getMenuEntry } from './Pages';

const Stylings = (
    <Route path=":viewName" element={<ViewByName/>} />
);

export default Stylings;


//Important to wrap Provider over the Element

function ViewByName():JSX.Element {
    const { viewName } = useParams<{ viewName: string }>();
    let entry = getMenuEntry(viewName as string);
    console.log(entry);

    return (
        <Stylingsview name={viewName} menuData={entry} />
    );
}